import _ from 'lodash';

export function paginate(data, config) {
    const current_page = _.get(config, 'current_page', 1);
    const per_page = _.get(config, 'per_page', 15);
    const total = _.size(data);

    const last_page = Math.ceil(total / per_page) || 1;

    return {
        current_page,
        last_page,
        per_page,
        total,
    }
}

export function slice(pagination, data) {
    const current_page = _.get(pagination, 'current_page', 1);
    const per_page = _.get(pagination, 'per_page', 15);

    const start = (current_page - 1) * per_page;
    const end = start + per_page;

    return _.slice(data, start, end);
}

export function getPage(pagination, index) {
    const per_page = _.get(pagination, 'per_page', 15);

    return Math.round(index / per_page);
}



// WEBPACK FOOTER //
// ./seventytwo/72cms-ui/src/utils/paginator.js